import { createSelector } from 'reselect'

export const stateSelector = state => state.api.get.one.meetings

export const data = () =>
  createSelector([stateSelector], getOneMeetingState => {
    if (getOneMeetingState.data) {
      return getOneMeetingState.data
    }
    return null
  })

export const isLoading = () =>
  createSelector(
    [stateSelector],
    getOneMeetingState => getOneMeetingState.isLoading
  )
